// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from "react";
import "./CreateClaimButton.scss";

import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";
import { firestore } from "../../context/FirebaseConfig";
import { doc, setDoc, updateDoc, increment, getDoc, serverTimestamp } from "firebase/firestore";

export default function CreateClaimButton({delivery}) {
    const { i18n, t } = useTranslation();
    const { currentUser, logEventCustom } = React.useContext(AuthContext);

    async function handleCreateClaim() {
        /* Create a new claim for the delivery */
        const claimNr = await getNewClaimNr();

        const deliveryRef = doc(firestore, "clients", currentUser.company.company, "deliveries", delivery.id);
        setDoc(deliveryRef, {
            claim_data: {
                claim_nr: claimNr,
                claim_status: "editing_dashboard",
                created_at: serverTimestamp(),
                created_by: currentUser.uid,
                created_by_displayname: currentUser.info.displayName,
            }
        }, {merge: true});

        logEventCustom("claim_created", {
            claim_nr: claimNr,
            delivery_id: delivery.id,
        });
    }

    async function getNewClaimNr() {
        /* Get the current claim counter and increment it */
        const claimSettingsRef = doc(firestore, "clients", currentUser.company.company, "client_settings", "claim_settings");
        const claimSettingsUpdated = await getDoc(claimSettingsRef);
        let claimNr = 1;
        if (claimSettingsUpdated.exists() && claimSettingsUpdated.data().claims_counter) {
            claimNr = claimSettingsUpdated.data().claims_counter + 1;
        }
        updateDoc(claimSettingsRef, {claims_counter: increment(1)});
        return claimNr;
    }

    return (
        <button 
            className="create-claim-button"
            onClick={handleCreateClaim}
        >
            {t("delivery_create_claim")}
        </button>
    );
}